export default {"src":"/_next/static/media/3D-BIM.97bd8cd9.svg","height":30,"width":21,"blurWidth":0,"blurHeight":0};